import {Button} from '@yandex-delivery/blocks'
import React from 'react'

import type {Props} from './GoToAppButton.types'

const Base: React.FC<Props> = ({onClick, text}) => (
  // @ts-expect-error требуется ивент, который onPress не пробрасывает. нужен рефактор
  <Button fullWidth onClick={onClick} textVariant="body2" variant="action">
    {text}
  </Button>
)

export const GoToAppButton = React.memo(Base)
